import { render, staticRenderFns } from "./CrudModal.vue?vue&type=template&id=38de681a&"
import script from "./CrudModal.ts?vue&type=script&lang=js&"
export * from "./CrudModal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports